import { B3dmHeader } from './types';

export const b3dmHeaderSize = 28;
const b3dmHeaderOffset: B3dmHeader = {
  versionId: 4,
  byteLength: 8,
  featureTableJSONLength: 12,
  featureTableBinaryByteLength: 16,
  batchTableJSONByteLength: 20,
  batchTableBinaryByteLength: 24,
};

/**
 *  Extracts header values from specified buffer using the header buffer offset.
 */
export const extractB3dmHeader = (b3dmBuffer: Buffer) => {
  return {
    versionId: b3dmBuffer.readUInt32LE(b3dmHeaderOffset.versionId),
    byteLength: b3dmBuffer.readUInt32LE(b3dmHeaderOffset.byteLength),
    featureTableJSONLength: b3dmBuffer.readUInt32LE(b3dmHeaderOffset.featureTableJSONLength),
    featureTableBinaryByteLength: b3dmBuffer.readUInt32LE(
      b3dmHeaderOffset.featureTableBinaryByteLength,
    ),
    batchTableJSONByteLength: b3dmBuffer.readUInt32LE(b3dmHeaderOffset.batchTableJSONByteLength),
    batchTableBinaryByteLength: b3dmBuffer.readUInt32LE(
      b3dmHeaderOffset.batchTableBinaryByteLength,
    ),
  };
};

export const getFeatureAndBatchByteLength = (header: B3dmHeader) => {
  return (
    header.featureTableJSONLength +
    header.featureTableBinaryByteLength +
    header.batchTableJSONByteLength +
    header.batchTableBinaryByteLength
  );
};
